import { z } from 'zod/v4';

export const ErrorCodeRuntype = z.enum([
    'additional_service.english_name_cannot_be_empty',
    'additional_service.german_name_cannot_be_empty',
    'additional_service.not_found',
    'assembly_api_imported_origin.invalid_json_format',
    'assembly.api_imported_assembly_missing_import_hash',
    'assembly.bom_file_not_found',
    'assembly.cannot_add_top_level_assembly_as_customer_user',
    'assembly.cannot_delete_top_level_assembly_as_customer_user',
    'activity_configuration.invalid_rank',
    'activity_configuration.not_found',
    'activity.internal_number_already_exists',
    'activity.name_already_exists',
    'activity.not_found',
    'assembly.designator_already_exists_among_siblings',
    'assembly.internal',
    'assembly.ipn_already_exists',
    'assembly.monitoring_subscriber_is_not_ems',
    'assembly.not_found',
    'assembly.parents_not_found',
    'assembly.pcb_not_found_for_assembly',
    'assembly.rfq_not_found_in_assembly',
    'auto_rfq_number_settings.cant_increment_manual_rfq_number',
    'auto_rfq_number_settings.invalid_auto_rfq_number_range',
    'award_scenario.action_not_supported_on_award_scenario',
    'award_scenario.invalid_awarded_price_types',
    'award_scenario.invalid_data',
    'award_scenario.name_conflict',
    'award_scenario.no_offer',
    'bad_request',
    'bom_export.cannot_delete_default_template',
    'bom_export.cannot_delete_last_template',
    'bom_export.cannot_update_default_status_of_default_template',
    'bom_export.should_contain_at_least_one_column',
    'bom_export.template_with_name_already_exists',
    'bom_import.bom_file_too_big',
    'bom_import.cannot_read_file',
    'bom_import.duplicate_designators',
    'calculation_assembly_cost.immutable_lock',
    'calculation_assembly_cost.internal',
    'calculation_assembly_cost.locked_cell_cannot_be_modified',
    'calculation_assembly_cost.not_found',
    'calculation_assembly_details.not_found',
    'calculation_cost.internal_error',
    'calculation.currency_error',
    'calculation.driver_resolver_error',
    'calculation.internal_error',
    'calculation_template.not_found',
    'comment.external_user_cannot_create_internal_comment',
    'comment.max_content_length',
    'comment.no_entity_found',
    'comment.not_found',
    'conflict',
    'costed_bom_export.no_sourcing_scenarios',
    'costed_bom_template.cannot_delete_default_template',
    'costed_bom_template.cannot_delete_last_template',
    'costed_bom_template.cannot_update_default_status_of_default_template',
    'costed_bom_template.should_contain_at_least_one_column',
    'costed_bom_template.template_with_name_already_exists',
    'customer_portal_settings.calculation_template_required',
    'customer_portal_settings.flexible_calculation_template_required',
    'customer_portal_settings.checkout_price_line_item_required',
    'customer_portal_settings.checkout_price_line_item_not_in_template',
    'customer_portal_settings.checkout_price_line_item_invalid',
    'customer_portal_settings.flexible_template_override_requires_flexible_org_mode',
    'customer_portal_settings.template_in_use_by_customer_portal',
    'customer_portal_settings.template_in_use_by_customer_specific_settings',
    'customer_portal_settings.internal',
    'customer_portal_settings.invalid_auto_rfq_number_range',
    'customer_portal_settings.invoice_days_must_be_greater_zero',
    'customer_portal_settings.manufacturing_template_required',
    'customer_portal_settings.minimum_quotations_lead_time_must_be_greater_than_zero',
    'customer_portal.checkout_price_unavailable',
    'customer_portal.internal',
    'customer_portal.single_top_level_assembly_not_found',
    'customer.billing_address_incomplete',
    'customer.has_referenced_demands',
    'customer.hashing_failed',
    'customer.invalid_country_code',
    'customer.name_unavailable',
    'customer.not_found',
    'customer.number_already_exists',
    'customer.payload_vat_identification_number_missing',
    'customer.payload_vat_identification_type_invalid',
    'customer.vat_id_incomplete',
    'customer.wrong_customer',
    'demand_group.cannot_delete_referenced',
    'demand_group.conflicting_ship_to_sites',
    'demand_scenario.delivery_batch_size_out_of_bounds',
    'demand_scenario.delivery_date_not_allowed',
    'demand_scenario.invalid_annual_demand',
    'demand_scenario.invalid_assembly_id',
    'demand_scenario.invalid_demand_scenario_end_year',
    'demand_scenario.invalid_demand_scenario_year',
    'demand_scenario.invalid_prototype_demand_scenario_quantity',
    'demand_scenario.missing_annual_demand',
    'demand_scenario.more_than_three_delivery_batch_sizes',
    'demand_scenario.multiple_annual_demands_for_one_year',
    'demand_scenario.no_annual_demands',
    'demand_scenario.prototype_demand_scenario_date_not_in_future',
    'demand.ambiguous_participant_site_number',
    'demand.assembly_demand_with_no_production_start_date',
    'demand.delivery_batch_size_out_of_bounds',
    'demand.invalid_annual_demand',
    'demand.invalid_assembly_id',
    'demand.invalid_dates',
    'demand.invalid_delivery_dates',
    'demand.invalid_demand_scenario_end_year',
    'demand.invalid_demand_scenario_year',
    'demand.invalid_prototype_demand_quantity',
    'demand.missing_annual_demand',
    'demand.more_than_three_delivery_batch_sizes',
    'demand.multiple_annual_demands_for_one_year',
    'demand.no_annual_demands',
    'demand.internal',
    'demand.invalid_quantity',
    'demand.missing_participant_site_information',
    'demand.no_calculated_demand_allowed_in_db',
    'demand.only_customer_number_or_customer_id_required',
    'demand.only_site_number_or_site_id_required',
    'demand.production_start_date_required',
    'demand.prototype_demand_scenario_date_not_in_future',
    'demand.supplier_is_not_ems',
    'design_item.belong_to_different_rfq',
    'design_item.incomplete_custom_option_information',
    'design_item.incomplete_part_suggestion',
    'design_item.incomplete_standard_part_information',
    'design_item.not_found',
    'design_item.quantity_unit_conversion_error',
    'design_item.rfq_not_found',
    'driver.first_char_must_be_letter',
    'driver.invalid_lexorank',
    'driver.invalid_package_name',
    'driver.name_already_exists',
    'driver.name_already_in_use',
    'driver.name_is_reserved_keyword',
    'driver.name_is_system_driver',
    'driver.name_must_be_alphanumeric',
    'driver.name_must_not_be_empty',
    'expense_configuration.invalid_rank',
    'expense_configuration.not_found',
    'expense.internal_number_already_exists',
    'expense.name_already_exists',
    'expense.not_found',
    'email_template.name.already_exists',
    'email_template.suppliers.conflict',
    'email.other_error',
    'email.payload_too_large',
    'flexible_calculation.locked_item_cannot_be_modified',
    'forbidden',
    'frontend_error.export.generic_error',
    'frozen_scenario_cost.already_frozen',
    'generic_part.invalid_parameter',
    'history_of_changes.invalid_creator',
    'history_of_changes.invalid_history_operation',
    'integration.error',
    'integration.invalid_api_key',
    'integration.invalid_credentials',
    'integration.invalid_settings',
    'integration.missing_api_key',
    'integration.rate_limited',
    'internal_auth.connection_name_mismatch',
    'internal_auth.connection_not_found',
    'internal_error',
    'invite.email_already_exists',
    'invite.invalid_email',
    'invite.invalid_user_invite',
    'invite.invite_already_sent',
    'invite.passwords_do_not_match',
    'ipn.deletion_limit_exceeded',
    'ipn.no_such_form_and_fit',
    'ipn.not_found',
    'manufacturer_preference.preference_with_manufacturer_and_category_already_exists',
    'manufacturer_preference.preference_with_part_category_already_exists',
    'manufacturer.alias_already_exists',
    'manufacturer.alias_conflicts_with_other_manufacturer',
    'manufacturer.alias_repeats_manufacturer_name',
    'manufacturer.duplicate_name',
    'manufacturer.empty_name',
    'manufacturer.empty_normalized_name',
    'manufacturer.invalid_data',
    'manufacturer.name_too_long',
    'manufacturer.unauthorized',
    'manufacturing_assembly_details.driver_does_not_use_sourcing_field',
    'manufacturing_assembly_details.not_found',
    'manufacturing_assembly_details.panel_factor_less_than_one',
    'manufacturing_scenario.internal',
    'manufacturing_scenario.invalid_batch_sizes',
    'manufacturing_scenario.name_already_exists',
    'manufacturing_scenario.not_found',
    'manufacturing_scenario_template_instance.illegal_template_reference',
    'manufacturing_scenario_template_instance.invalid_rank',
    'manufacturing_scenario_template_instance.not_found',
    'manufacturing_scenario_template.name_already_exists',
    'manufacturing_scenario_template.not_found',
    'monitoring.export.not_ready',
    'negotiation_part.invalid_data',
    'negotiation_v2_creation.demand_group_name_invalid',
    'negotiation_v2_creation.duplicate_sourcing_scenario_name',
    'negotiation_v2_creation.name_invalid',
    'negotiation_v2_creation.sourcing_scenario_name_invalid',
    'negotiation.different_negotiation',
    'negotiation.not_found',
    'not_found',
    'off_the_shelf_offer.not_found',
    'off_the_shelf.duplicated_mpn',
    'off_the_shelf.invalid_emission_data',
    'off_the_shelf.mpn_length_violation',
    'off_the_shelf.package_violation',
    'off_the_shelf.part_already_exists',
    'offer_origin.cannot_store_consigned',
    'offer.cannot_delete_public_off_the_shelf_offers',
    'offer.cannot_delete_referenced_offers',
    'offer.early_payment_due_days_must_be_positive',
    'offer.invalid_db_state',
    'offer.invalid_off_the_shelf_id',
    'offer.invalid_payment_terms',
    'offer.net_payment_due_days_must_be_positive',
    'offer.not_found',
    'offer_import_context.duplicate_name',
    'offer_import_context.in_use_by_offers',
    'offer_import_context.internal',
    'offer_import_context.not_found',
    'offer_import_context.validation_failed',
    'order.internal',
    'order.not_found',
    'order.order_selection_options_not_found',
    'order.payment_method_not_allowed',
    'order.sourcing_offers_pending',
    'order.tax_id_invalid',
    'order.unauthorized',
    'part_search.exclusive_filters',
    'part_search.generic_part_to_search',
    'panel.generation.pcb_height_exceeds_panel',
    'panel.generation.pcb_width_exceeds_panel',
    'panel.generation.unknown_error',
    'payload.cannot_be_both_customer_and_supplier_user',
    'payload.customer_company_name_cannot_be_empty',
    'payload.customer_portal_invalid_assembly_type',
    'payload.customer_portal_invalid_pcb_workflow_settings',
    'payload.email_cannot_be_empty',
    'payload.first_name_cannot_be_empty',
    'payload.invoice_days_before_due_must_be_greater_than_zero',
    'payload.last_name_cannot_be_empty',
    'payload.lead_time_must_be_greater_than_zero',
    'payload.password_cannot_contain_personal_data',
    'payload.password_mismatch',
    'payload.payment_id_cannot_be_null',
    'payload.payment_processor_cannot_be_null',
    'payload.private_key_cannot_be_empty',
    'payload.public_key_cannot_be_empty',
    'payload.standard_quotation_lead_time_days_cannot_be_null',
    'payload.tenant_cannot_be_empty',
    'payload.vat_identification_number_cannot_be_empty',
    'payload.weak_password',
    'payment.already_scheduled_for_refunded',
    'payment.amount_mismatch',
    'payment.invalid_currency',
    'payment.no_configured_payment_processor',
    'payment.not_found',
    'payment.refunded',
    'payment.scheduled_for_refunded',
    'pcb_specification_importer.pcb_specification.error_extracting_pcb_specification',
    'pcb_specification_importer.pcb_specification.error_file_required',
    'pcb.json',
    'pcb.panel',
    'pcb.reqwest',
    'pnp_file.not_found',
    'pnp_importer.column_missing',
    'pnp_importer.csv',
    'pnp_importer.empty_pnp_file',
    'pnp_importer.invalid_mapping',
    'pnp_importer.invalid_rfq_state',
    'pnp_importer.multiple_mapping',
    'pnp_item.not_found',
    'project_creation.assembly_name_invalid_length',
    'project_creation.delivery_start_date_must_be_before_end_date',
    'project_creation.demand_group_description_invalid_length',
    'project_creation.demand_group_name_invalid_length',
    'project_creation.duplicate_sourcing_scenario_name',
    'project_creation.existing_assembly_must_have_same_customer',
    'project_creation.internal_project_number_invalid_length',
    'project_creation.lower_estimate_must_not_be_negative',
    'project_creation.project_group_name_invalid_length',
    'project_creation.sourcing_scenario_name_invalid_length',
    'project_creation.upper_estimate_must_not_be_negative',
    'purchase_order.cannot_infer_sourcing_scenario',
    'purchase_order.conflict',
    'purchase_order.no_line_items',
    'purchase_order.no_recipient',
    'purchase_order.no_sender',
    'purchase_order.not_found',
    'query.rfq_id_missing',
    'quotation.document_already_exists',
    'quotation.internal',
    'quotation.unauthorized',
    'quote_importer.extraction',
    'quote_importer.general',
    'quote_importer.invalid_factory_lead_time',
    'quote_importer.invalid_lead_time',
    'quote_importer.invalid_moq',
    'quote_importer.invalid_mpq',
    'llm.custom_part_offer.error_extracting_offer',
    'llm.custom_part_offer.error_file_required',
    'llm.custom_part_offer.error_incomplete_response',
    'llm.custom_part_offer.error_streaming_file',
    'llm.custom_part_offer.error_too_many_items',
    'llm.off_the_shelf_offer.error_extracting_offer',
    'llm.off_the_shelf_offer.error_file_required',
    'llm.off_the_shelf_offer.error_incomplete_response',
    'llm.off_the_shelf_offer.error_too_many_line_items',
    'quote_importer.invalid_unit_of_measurement',
    'quote_importer.negative_factory_quantity',
    'quote_importer.negative_stock',
    'quote_importer.negative_unit_price',
    'quote_importer.no_supplier',
    'quote_importer.part_not_found',
    'quote_importer.suppliers_not_equal',
    'quote_importer.unsupported_part_type',
    'quote_import.custom_part_not_found',
    'quote_import.factory_lead_time_negative_or_zero',
    'quote_import.factory_quantity_negative',
    'quote_import.invalid_payment_terms',
    'quote_import.invalid_unit_of_measurement',
    'quote_import.lead_time_negative_or_zero',
    'quote_import.line_items_not_found_for_quote_request',
    'quote_import.many_offers_for_single_quote_request_line_item',
    'quote_import.moq_negative_or_zero',
    'quote_import.mpq_negative_or_zero',
    'quote_import.requested_off_the_shelf_part_not_found',
    'quote_import.stock_negative',
    'quote_import.supplier_and_stock_location_not_found',
    'quote_import.unit_price_negative',
    'quote_import.unsupported_part_type',
    'quote_request_export.comparison_error',
    'quote_request_export.missing_value',
    'quote_request_export.quantity_error',
    'quote_request_export.too_many_overlapping_solution_configurations',
    'quote_request.both_negotiation_line_items_and_solution_configuration_provided',
    'quote_request.cannot_approve_without_offer',
    'quote_request.invalid_approval_status_transition',
    'quote_request.supplier_cannot_approve',
    'quote_request.approval_status_notes_too_long',
    'quote_request.cannot_send_empty_quote_request',
    'quote_request.cannot_send_in_current_status',
    'quote_request.contacts_with_different_suppliers',
    'quote_request.custom_part_not_found',
    'quote_request.different_projects',
    'quote_request.different_rfq',
    'quote_request.draft_already_in_project',
    'quote_request.excel_generation_failure',
    'quote_request.factory_lead_time_negative_or_zero',
    'quote_request.factory_quantity_negative',
    'quote_request.failed_to_duplicate_line',
    'quote_request.failed_to_get_internal_rfq_contributors',
    'quote_request.failed_writing_attachments_to_zip',
    'quote_request.file_not_found',
    'quote_request.incorrect_quote_request_line_item_unit',
    'quote_request.invalid_approval_status_transition',
    'quote_request.invalid_data',
    'quote_request.invalid_email_body',
    'quote_request.invalid_email_subject',
    'quote_request.invalid_payment_terms',
    'quote_request.invalid_unit_of_measurement',
    'quote_request.lead_time_negative_or_zero',
    'quote_request.line_items_not_found_for_quote_request',
    'quote_request.many_offers_for_single_quote_request_line_item',
    'quote_request.missing_user',
    'quote_request.moq_negative_or_zero',
    'quote_request.mpq_negative_or_zero',
    'quote_request.multiple_emails_for_quote_request',
    'quote_request.multiple_quote_requests_not_sent_for_supplier',
    'quote_request.negotiation_line_items_not_found',
    'quote_request.no_email_recipients',
    'quote_request.no_negotiation_or_project',
    'quote_request.not_found',
    'quote_request.not_linked_to_valid_entity',
    'quote_request.provided_rfq_and_sourcing_scenario_rfq_mismatch',
    'quote_request.quote_request_line_item_not_found',
    'quote_request.requested_off_the_shelf_part_not_found',
    'quote_request.sourcing_scenarios_missing_rfq',
    'quote_request.stock_negative',
    'quote_request.supplier_and_stock_location_not_found',
    'quote_request.supplier_cannot_approve',
    'quote_request.supplier_contact_without_user',
    'quote_request.unit_price_negative',
    'quote_request.unsupported_part_type',
    'refund.already_refunded',
    'refund.already_scheduled_for_refund',
    'refund.duplicate_transaction',
    'resource.name_already_exists',
    'resource.not_found',
    'rfq.cannot_create_customer_as_customer_user',
    'rfq.cannot_create_rfq_for_different_customer',
    'rfq.cannot_update_archived',
    'rfq.customer_does_not_exist',
    'rfq.customer_user_has_no_customer',
    'rfq.delete_rfq_with_part_in_negotiation',
    'rfq.delete_rfq_with_sales_order_prohibited',
    'rfq.duplicate_assembly_names',
    'rfq.duplicate_order_sizes',
    'rfq.duplication_failed',
    'rfq.empty_update_prohibited',
    'rfq.invalid_assembly_name',
    'rfq.invalid_creator',
    'rfq.invalid_customer_name',
    'rfq.invalid_name',
    'rfq.invalid_operation',
    'rfq.invalid_order_date',
    'rfq.invalid_order_size',
    'rfq.invalid_rfq_number',
    'rfq.invalid_status',
    'rfq.invalid_status_for_archiving',
    'rfq.invalid_volume_estimate_bounds',
    'rfq.invalid_workflow_for_operation',
    'rfq.missing_shipping_tracking_link',
    'rfq.new_customer_name_unavailable',
    'rfq.not_found',
    'rfq.request_in_draft_only_allowed_if_customer_portal_is_enabled',
    'rfq.unauthorized',
    'rfq.unauthorized_status_update',
    'rfq.unauthorized_to_create',
    'rfq.workflow_changes_only_allowed_by_ems',
    'role.calculation_module_restricted_for_manufacturing_lite',
    'role.manage_manufacturing_restricted_for_manufacturing_lite',
    'role.manufacturing_module_restricted_for_calculation_without_manufacturing',
    'scenario_combination.batch_size_not_found',
    'scenario_combination.invalid_batch_size',
    'scenario_combination.invalid_sourcing_scenario',
    'scenario_combination.manufacturing_scenario_not_found',
    'scenario_combination.not_found',
    'scenario_combination.sourcing_scenario_not_found',
    'snapshot.notes_too_long',
    'self_signup_settings.contact_person_must_be_from_ems',
    'self_signup_settings.contact_person_not_found',
    'self_signup_settings.invalid_color_scheme',
    'self_signup_settings.invalid_organization_logo',
    'site.cannot_create_sourcing_site',
    'site.cannot_delete_default_inventory_site',
    'site.cannot_delete_inventory_site_with_linked_inventory_offers',
    'site.cannot_remove_default_setting_from_last_inventory_site',
    'site.cannot_remove_default_setting_from_last_site_with_tag',
    'site.cannot_remove_tag',
    'site.invalid_default_site_setting',
    'site.must_have_at_least_one_tag',
    'site.name_already_exists',
    'site.not_found',
    'site.payload_address_cannot_be_empty',
    'site.payload_city_cannot_be_empty',
    'site.payload_invalid_country_code',
    'site.payload_name_cannot_be_empty',
    'site.payload_note_cannot_be_empty',
    'site.payload_postcode_cannot_be_empty',
    'site.site_number_already_exists',
    'solution_configuration.cannot_set_manual_costs_on_automatic_solution',
    'solution_configuration.cannot_set_manual_solution_and_manual_sourced_by_at_the_same_time',
    'solution_configuration.cannot_set_manual_solution_and_manual_status_at_the_same_time',
    'solution_configuration.cannot_set_manual_status_on_automatic_solution',
    'solution_configuration.invalid_offers',
    'solution_configuration.invalid_scrap_quantity',
    'solution_configuration.invalid_selection',
    'solution_configuration.no_design_items',
    'solution_configuration.no_part_options',
    'solution_configuration.not_found',
    'solution_configuration.offer_loading_error',
    'solution_configuration.part_demands_not_supported',
    'solution_configuration.solution_not_found',
    'sourcing_scenario.cannot_find_sourcing_settings',
    'sourcing_scenario.data_source_both_included_and_excluded',
    'sourcing_scenario.demand_cannot_be_zero',
    'sourcing_scenario.empty_assembly_quantities',
    'sourcing_scenario.invalid_abc_classification_settings',
    'sourcing_scenario.invalid_demand_data',
    'sourcing_scenario.name_too_long',
    'sourcing_scenario.invalid_project_link',
    'sourcing_scenario.missing_name',
    'sourcing_scenario.name_already_exists',
    'sourcing_scenario.not_found',
    'sourcing_line_item.could_not_find_offer_for_target_sourcing_line_item',
    'sourcing_line_item.could_not_find_offer_for_origin_sourcing_line_item',
    'sourcing_line_item.could_not_find_origin_sourcing_line_item',
    'sourcing_line_item.invalid_siblings',
    'sourcing_line_item.trying_to_sync_line_item_without_offers',
    'sourcing_settings.can_not_find_default_sourcing_settings',
    'sourcing_settings.failed_to_convert_to_upsert',
    'sourcing_settings.got_invalid_currency',
    'sourcing_settings.invalid_abc_classification_settings',
    'sourcing_settings.invalid_offer_validation_window',
    'sourcing_settings.invalid_site_id_update',
    'sourcing_settings.invalid_sourcing_settings_id',
    'sourcing_settings.invalid_supplier_and_stock_location_id_update',
    'sourcing_settings.multiple_solution_preferences',
    'sourcing_settings.no_upsert_result',
    'sourcing_settings.not_found',
    'sourcing_settings.tried_to_insert_non_approved_supplier',
    'sourcing_template.data_source_both_included_and_excluded',
    'sourcing_template.failed_to_find_default',
    'sourcing_template.failed_to_find_sourcing_schema_default',
    'sourcing_template.failed_to_find_sourcing_settings',
    'sourcing_template.invalid_abc_classification_settings',
    'sourcing_template.missing_name',
    'sourcing_template.not_found',
    'sourcing_template.tried_to_delete_default',
    'sourcing_template.unauthorized',
    'stock_location.not_found',
    'supplier_and_stock_location.already_exists',
    'supplier_contact.cannot_edit_invited_supplier_contact',
    'supplier_contact.cannot_edit_public_supplier_contact',
    'supplier_contact.contact_has_associated_user',
    'supplier_contact.email_already_exists_as_user',
    'supplier_contact.email_invalid',
    'supplier_contact.invalid_main_contact',
    'supplier_contact.multiple_main_contact_insertions',
    'supplier_contact.name_invalid',
    'supplier_contact.only_contact_must_remain_main',
    'supplier_contact.phone_number_not_allowed_on_public_contact',
    'supplier_contact.unique_email_supplier_and_stock_location_violation',
    'supplier_contact.unknown_supplier',
    'supplier_contact.user_language_not_supported',
    'supplier_terms.already_exists',
    'supplier_terms.not_found',
    'supplier_terms.payment_due_days_constraint_violation',
    'supplier.duplicate_supplier_number',
    'supplier.invalid_update_on_system_supplier',
    'supplier.name.already_exists',
    'supplier.name.empty',
    'supplier.not_found',
    'supplier.public_supplier_by_tenant_deletion',
    'supplier.supplier_number.already_exists',
    'supplier.supplier_number.empty',
    'supplier.supplier_number.not_found',
    'too_large',
    'total_cost_of_ownership_rule.absolute_cost_cannot_be_negative',
    'total_cost_of_ownership_rule.conditions_cannot_be_empty',
    'total_cost_of_ownership_rule.invalid_customs_code',
    'total_cost_of_ownership_rule.invalid_name',
    'total_cost_of_ownership_rule.not_found',
    'total_cost_of_ownership_rule.relative_cost_must_be_percentage',
    'unauthorized',
    'unknown',
    'unprocessable_entity',
    'user.customer_id_missing',
    'user.failed_to_create_user',
    'user.has_made_a_payment',
    'user.invalid_email',
    'user.invalid_first_name',
    'user.invalid_last_name',
    'user.invalid_password',
    'user_invite.internal_role_for_external_user',
    'user.not_found',
    'frontend_error.export.generic_error',
    'sourcing_template.tried_to_delete_default',
    'auth.missing_auth_info',
    'auth.must_be_customer_user',
    'auth.must_use_password_auth',
    'auth.invalid_role',
    'auth.role_conflict',
    'auth.tenant_not_set_in_session',
    'pcb_specification_template.not_found',
    'pcb_specification_template.customer_already_assigned',
    'pcb_specification_csv_export.no_visible_fields',
    'pcb_specification_csv_export.validated_token_missing',
    'pcb_specification_preferences.visible_fields_required',
    'custom_part_category.duplicate_name',
    'custom_part_category.depth_exceeds_maximum',
    'custom_part_category.cannot_create_system_or_import_category',
    'custom_part_category.cannot_edit_system_or_import_category',
    'custom_part_category.cannot_delete_system_or_import_category',
    'custom_part_category.not_found',
    'custom_part_category.parent_not_found',
    'custom_part_category.validation_error',
    'custom_part_offer.conversion_failed',
    'custom_part_offer.invalid_db_state',
    'custom_part_offer.invalid_payment_terms',
    'custom_part_offer.missing_custom_part_specification',
    'custom_part_specification.invalid_db_state',
    'custom_part_specification.cannot_update_custom_part_to_pcb',
    'custom_part_specification.cannot_update_pcb_to_custom_part',
    'custom_part_specification.description_too_long',
    'custom_part_specification.drawing_number_too_long',
    'custom_part_specification.revision_too_long',
    'custom_part_specification.sourcing_notes_too_long',
    'custom_part_specification.in_use_by_design_items',
    'custom_part.duplicate_supplier_part_number',
    'delete_manual_supplier.internal',
]);

export type ErrorCode = z.infer<typeof ErrorCodeRuntype>;
